import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { TextConfigurationItem } from '../types-store';

export const normalizeTextItem = (textItem: TextConfigurationItem): TextConfigurationItem => {
  return {
    ...(!!textItem && isDefinedIncludingZero(textItem.id) && { id: textItem.id }),
    ...(!!textItem && !!textItem.textSet && isDefinedIncludingZero(textItem.textSet.value) && { textSet: textItem.textSet }),
    textCollection: textItem && textItem.textCollection || [],
    translations: textItem && textItem.translations
      && textItem.translations.map(
        language => ({ ...language, text: language.text?.trim() })
      ) || []
  } as TextConfigurationItem;
};
